import type { BlogPage, EnrichedBlogPage } from '../blog.model';

export function enrichBlogPages(
  blogPages: BlogPage[] = []
): EnrichedBlogPage[] {
  return blogPages.map((blogPage) => {
    let tagArray: string[] = [];
    if (blogPage.tags.value) {
      tagArray = blogPage.tags.value.split(',').map((s) => s.trim());
    }

    return {
      ...blogPage,
      tagArray,
      createdAtDate: new Date(blogPage.createdAt.jss.value),
    };
  });
}
